import { Injectable, Component, OnInit, Input } from "@angular/core";

declare var $: any;

@Component({
  selector: "app-notificaciones",
  templateUrl: "./notificaciones.component.html"
})
export class NotificacionesComponent {}

@Injectable({
  providedIn: "root"
})
export class MuestraMensaje {
  constructor() {}

  notification(message, from, align) {
    var type = ["",  "success",];

    var color = Math.floor(Math.random() * 1 + 1);

    $.notify(
      {
        icon: "nc-icon nc-bell-55",
        message: message
      },
      {
        type: type[color],
        timer: 1000,
        placement: {
          from: from,
          align: align
        },
        template:
          '<div data-notify="container" class="col-11 col-md-4 alert alert-{0} alert-with-icon" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss"><i class="nc-icon nc-simple-remove"></i></button><span data-notify="icon" ></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
      }
    );
  }

  error(message, from, align) {
    var type = ["", "danger"];

    var color = Math.floor(Math.random() * 1 + 1);      //"info", "success", "warning" estos son los colores que estaban antes.

    $.notify(
      {
        icon: "nc-icon nc-sound-wave",
        message: message
      },
      {
        type: type[color],
        timer: 1000,
        placement: {
          from: from,
          align: align
        },
        template:
          '<div data-notify="container" class="col-11 col-md-4 alert alert-{0} alert-with-icon" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss"><i class="nc-icon nc-simple-remove"></i></button><span data-notify="icon" ></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
      }
    );
  }
  errorTimer(message, from, align,timer) {
    var type = ["", "danger"];

    var color = Math.floor(Math.random() * 1 + 1);      //"info", "success", "warning" estos son los colores que estaban antes.

    $.notify(
      {
        icon: "nc-icon nc-sound-wave",
        message: message
      },
      {
        type: type[color],
        timer: timer,
        placement: {
          from: from,
          align: align
        },
        template:
          '<div data-notify="container" class="col-11 col-md-4 alert alert-{0} alert-with-icon" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss"><i class="nc-icon nc-simple-remove"></i></button><span data-notify="icon" ></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
      }
    );
  }
  warning(message, from, align) {
    var type = ["", "warning"];
  
    // Seleccionar el color para la notificación de tipo warning
    var color = Math.floor(Math.random() * 1 + 1);
  
    $.notify(
      {
        icon: "nc-icon nc-alert-circle-i",
        message: message
      },
      {
        type: type[color],
        timer: 1000,
        placement: {
          from: from,
          align: align
        },
        template:
        '<div data-notify="container" class="col-11 col-md-4 alert alert-{0} alert-with-icon" role="alert" style="color: black;">' +
        '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">' +
        '<i class="nc-icon nc-simple-remove"></i></button>' +
        '<span data-notify="icon"></span> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
      }
    );
  }
  
}
